import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { PATH } from '../../../../constants/path';
import { HeadComponent } from '../../../HeadComponent';
import PaymentAreaComponent from './PaymentAreaComponent';
import { PAYMENT_THRESHOLD } from '../../../../constants';
import ResumeCashbackComponent from './ResumeCashbackComponent';
import CashbackHistoryComponent from './CashbackHistoryComponent';
import { getWaitingAmount } from '../../../../services/account/gains/selector';
import { getValidatedAmount } from '../../../../services/account/gains/selector';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';
import { fetchBankCreditCardIfNeeded } from '../../../../services/bankcreditcard/actions';
import { fetchPaymentRequestOnGoingIfNeeded } from '../../../../services/account/paymentrequest/ongoing/actions';

import './AccountPurchase.scss';

export class AccountPurchasePage extends React.Component {
    componentDidMount() {
        const { fetchPaymentRequestOnGoingIfNeeded, fetchBankCreditCardIfNeeded } = this.props;

        fetchPaymentRequestOnGoingIfNeeded();
        fetchBankCreditCardIfNeeded();
    }

    render() {
        const { validatedAmount, waitingAmount, i18nPage } = this.props;

        return (
            <main id="p-compte-cagnottecashback">
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_JACKPOT_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <ResumeCashbackComponent
                    totalCashback={validatedAmount + waitingAmount}
                    cssClassLeft="valid"
                    leftAmount={validatedAmount}
                    cssClassRight="pending"
                    rightAmount={waitingAmount}
                />
                <PaymentAreaComponent thresholdReached={validatedAmount >= PAYMENT_THRESHOLD} />
                <CashbackHistoryComponent />
            </main>
        );
    }
}

AccountPurchasePage.propTypes = {
    validatedAmount: PropTypes.number,
    waitingAmount: PropTypes.number,
    i18nPage: PropTypes.object.isRequired,
    fetchPaymentRequestOnGoingIfNeeded: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        validatedAmount: getValidatedAmount(state),
        waitingAmount: getWaitingAmount(state),
        i18nPage: state.i18n.page.ACCOUNT.CASHBACK
    };
}

const mapDispatchToProps = {
    fetchPaymentRequestOnGoingIfNeeded,
    fetchBankCreditCardIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountPurchasePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/AccountPurchasePage.js